import * as React from "react";
import { useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import {
    ClientToServerMessage,
    WSAPI,
    PartyInfo,
    ServerToClientMessage,
    AI,
} from "../apis/ws_api";
import { Game } from "../ui/Game";
import { Lobby } from "../ui/Lobby";

// Useful to set when debugging
// Set to empty string in production
//const SERVER_HOST = 'http://localhost:8000';
const SERVER_HOST = "";

export function Menu(): React.JSX.Element {
    const [roomName, setRoomName] = useState<string>("");
    const [socket, setSocket] = useState<WebSocket>(null);
    const [partyInfo, setPartyInfo] = useState<PartyInfo>(null);
    const [playerName, setPlayerName] = useState<string>("");

    const gameAPI = useRef<WSAPI>(null);
    const [game, setGame] = useState<React.JSX.Element>(null);

    const validSettings =
        roomName.length > 0 &&
        !roomName.includes("/") &&
        playerName.length > 0 &&
        !playerName.includes("?") &&
        !playerName.includes("&");

    if (game) {
        return game;
    } else if (socket != null && partyInfo == null) {
        return (
            <div>
                <p>Connecting to {roomName}</p>
            </div>
        );
    } else if (partyInfo != null) {
        return (
            <dialog open className="multiplayer-lobby">
                <p>Connected to {roomName}</p>
                <Lobby
                    players={partyInfo.players}
                    ais={partyInfo.ais}
                    addAI={(x: AI) => {
                        const event = {
                            type: "AddAI",
                            difficulty: x,
                        };
                        socket.send(JSON.stringify(event));
                    }}
                    deleteAI={(i: number) => {
                        const event = {
                            type: "RemoveAI",
                            index: i,
                        };
                        socket.send(JSON.stringify(event));
                    }}
                />
                <div className="flex-container" style={{ paddingTop: "1em" }}>
                    <button
                        onClick={() => {
                            socket.close();
                            setSocket(null);
                            setPartyInfo(null);
                            gameAPI.current = null;
                        }}
                    >
                        Disconnect
                    </button>
                    <button
                        onClick={() => {
                            const event: ClientToServerMessage = {
                                type: "StartGame",
                            };
                            socket.send(JSON.stringify(event));
                        }}
                    >
                        Start Game
                    </button>
                </div>
            </dialog>
        );
    } else {
        return (
            <dialog open>
                <div className="multiplayer-inputs-grid">
                    <label>
                        Room Name:
                        <input
                            type="text"
                            value={roomName}
                            onChange={(e) => {
                                setRoomName(e.target.value);
                            }}
                        ></input>
                    </label>
                    <label>
                        Player Name:
                        <input
                            type="text"
                            value={playerName}
                            onChange={(e) => {
                                setPlayerName(e.target.value);
                            }}
                        ></input>
                    </label>

                    <button
                        disabled={!validSettings}
                        onClick={() => {
                            let socket = new WebSocket(
                                `${SERVER_HOST}/room/${roomName}?player_name=${playerName}`,
                            );
                            socket.addEventListener("message", (event) => {
                                const input: ServerToClientMessage = JSON.parse(
                                    event.data,
                                );
                                if (input.type == "RoomChange") {
                                    setPartyInfo(input.info);
                                } else if (
                                    input.type == "GameEvent" &&
                                    game == null
                                ) {
                                    // start game
                                    if (gameAPI.current == null) {
                                        gameAPI.current = new WSAPI(socket);
                                    }
                                    setGame(
                                        <Game
                                            api={gameAPI.current}
                                            settings={{
                                                playerName: playerName,
                                                trayLength: 7,
                                            }}
                                            end_game_fn={function (): void {
                                                socket.close();
                                                setSocket(null);
                                                setPartyInfo(null);
                                                setGame(null);
                                                gameAPI.current = null;
                                            }}
                                        />,
                                    );
                                } else if (input.type == "Disconnection") {
                                    socket.close();
                                    alert(
                                        `Disconnected with reason: ${input.reason}`,
                                    );
                                } else {
                                    console.error(
                                        "Received error type message from server",
                                    );
                                    console.error({ input });
                                    socket.close(
                                        1001,
                                        "Received some kind of error; see logs",
                                    );
                                }
                                //console.log("Message from server ", event.data);
                            });
                            socket.addEventListener("close", (event) => {
                                console.log({ event });
                                setSocket(null);
                                setPartyInfo(null);
                                setGame(null);
                                gameAPI.current = null;
                                if (
                                    event.reason != null &&
                                    event.reason.length > 0
                                ) {
                                    alert(
                                        `Disconnected with reason "${event.reason} & code ${event.code}"`,
                                    );
                                }
                            });
                            setSocket(socket);
                        }}
                    >
                        Connect
                    </button>
                </div>
            </dialog>
        );
    }
}

async function run() {
    const root = createRoot(document.getElementById("root"));
    root.render(<Menu />);
}

run();
